export default __webpack_public_path__ + "static/media/BLUENet Repeater.de66784b.jpg";